import { useReducer } from "react";
import { GlobalContext } from "./GlobalContext";

const win = window;
let lang;

if (window.location.href.includes("localhost")) {
  lang = "en";
  !!!win['base_portal_url'] && (win['base_portal_url'] = 'http://ssta004:8080')
} else {
  lang = document.documentElement.lang;
  win['base_portal_url'] = window.location.origin;
}
!!!win['ftth_track_order_url'] && (win['ftth_track_order_url'] = '/wps/portal/web/personal/home-services/ftth-setup-track-status');

const rtl = lang === "ar";
!!!win["lang"] && (win["lang"] = lang);
document.documentElement.lang = lang;
document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
const dir = lang === null || lang === "en" ? "ltr" : "rtl";
win['requestFlow'] = 'installation';
const initialState = {
  rtl,
  dir,
  lang,
  loading: false,
  center: {},
  msisdn: '',
  refId: '',
  smsSentTo: '',
  page: 'map',
  mapData: { address: '', latLng: '' },
  formData: {},
  popup: '',
  shoppingCart: {
    "context": {
      "channel": {
        "id": "bo_lov_portals",
        "name": "Portals",
      },
      "serviceability": {},
    }
  },
  checkoutStructure: {},
  CheckCoverageResponse: '',
  postProductResponse: {},
  orderRequestData: {},
  requestFlow: 'installation',
  successType: '',
  otpType: ''
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_LOADER":
      return {
        ...state,
        loading: action.payload,
      };

    case "SET_CENTER":
      return {
        ...state,
        center: action.payload.center,
      };
    case "SET_MSISDN":
      return {
        ...state,
        msisdn: action.payload.msisdn,
        refId: action.payload.refId,
        smsSentTo: action.payload.smsSentTo,
      };
    case "UPDATE_COVERAGE_RES":
      return {
        ...state,
        CheckCoverageResponse: action.payload
      }
    case "UPDATE_PAGE":
      return {
        ...state,
        page: action.payload,
        popup: ''
      };
    case "UPDATE_POPUP":
      return {
        ...state,
        popup: action.payload,
      };
    case "UPDATE_ORDER_REQUEST_DATA":
      return {
        ...state,
        orderRequestData: action.payload,
      };
    case "CURRENT_MAP_VALUE":
      return {
        ...state,
        mapData: action.payload
      }
    case "FORM_DATA":
      return {
        ...state,
        formData: action.payload
      }
    case "UPDATE_SHOPPING_CART":
      return {
        ...state,
        shoppingCart: action.payload
      }
    case "UPDATE_CHECKOUT_STRUCTURE":
      return {
        ...state,
        checkoutStructure: action.payload
      }
    case "UPDATE_POST_PRODUCT_RESPONSE":
      return {
        ...state,
        postProductResponse: action.payload
      }
    case "UPDATE_REQUEST_FLOW":
      win['requestFlow'] = action.payload;
      return {
        ...state,
        requestFlow: action.payload
      }
    case "UPDATE_SUCCESS_TYPE":
      return {
        successType: action.payload
      }
    case "RESET_DATA":
      return {
        ...initialState,
      }
    default:
      return state;
  }
};

export const GlobalProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <GlobalContext.Provider value={{ state, dispatch }}>
      {props.children}
    </GlobalContext.Provider>
  );
};
